"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Copyright (c) Qwoach LLC 2023. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 20.10.23
 *
 */
var ProxyManager = /*#__PURE__*/function () {
  function ProxyManager() {
    (0, _classCallCheck2["default"])(this, ProxyManager);
  }

  (0, _createClass2["default"])(ProxyManager, [{
    key: "enableProxy",
    value: function enableProxy(proxySettings, analyticsProxySettingsArray) {
      if (window.fetch) {
        this.enableProxyFetch(proxySettings, analyticsProxySettingsArray);
      }

      if (window.XMLHttpRequest) {
        this.enableProxyAjax(proxySettings, analyticsProxySettingsArray);
      }
    }
  }, {
    key: "enableProxyFetch",
    value: function enableProxyFetch(proxySettings, analyticsProxySettingsArray) {
      var _this = this;

      var _window = window,
          originalFetch = _window.fetch;
      window.fetch = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _len,
            args,
            _key,
            resource,
            config,
            response,
            isProxyRequest,
            _iterator,
            _step,
            analyticsSettings,
            _args = arguments;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }

                resource = args[0], config = args[1];
                isProxyRequest = false;
                _iterator = _createForOfIteratorHelper(analyticsProxySettingsArray);
                _context.prev = 4;

                _iterator.s();

              case 6:
                if ((_step = _iterator.n()).done) {
                  _context.next = 15;
                  break;
                }

                analyticsSettings = _step.value;

                if (!(resource.url.indexOf(analyticsSettings.urlMask) >= 0)) {
                  _context.next = 13;
                  break;
                }

                isProxyRequest = true;
                _context.next = 12;
                return _this.sendProxyRequestFetch(_objectSpread(_objectSpread({}, proxySettings), analyticsSettings), originalFetch, resource, config);

              case 12:
                response = _context.sent;

              case 13:
                _context.next = 6;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](4);

                _iterator.e(_context.t0);

              case 20:
                _context.prev = 20;

                _iterator.f();

                return _context.finish(20);

              case 23:
                if (isProxyRequest) {
                  _context.next = 27;
                  break;
                }

                _context.next = 26;
                return originalFetch.apply(void 0, args);

              case 26:
                response = _context.sent;

              case 27:
                return _context.abrupt("return", response);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 17, 20, 23]]);
      }));
    }
  }, {
    key: "enableProxyAjax",
    value: function enableProxyAjax(proxySettings, analyticsSettingsArray) {
      var thisManager = this;
      var originalSend = window.XMLHttpRequest.prototype.send;
      var originalOpen = window.XMLHttpRequest.prototype.open;
      var originalSetRequestHeader = window.XMLHttpRequest.prototype.setRequestHeader;

      window.XMLHttpRequest.prototype.open = function (method, url) {
        this._method = method;
        this._url = url;
        this._headers = {};
        originalOpen.apply(this, arguments);
      };

      window.XMLHttpRequest.prototype.send = function (data) {
        thisManager.log("Analytics proxy request XMLHttpRequest.send: ", arguments, " this = ", this);
        var isProxyRequest = false;

        var _iterator2 = _createForOfIteratorHelper(analyticsSettingsArray),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var analyticsSettings = _step2.value;

            if (resource.url.indexOf(analyticsSettings.urlMask) >= 0) {
              isProxyRequest = true;
              thisManager.sendProxyRequestAjax(_objectSpread(_objectSpread({}, proxySettings), analyticsSettings), this, data);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (!isProxyRequest) {
          originalSend.apply(this, arguments);
        }
      };

      window.XMLHttpRequest.prototype.setRequestHeader = function () {
        thisManager.log("Analytics proxy request XMLHttpRequest.setRequestHeader: ", arguments, " this = ", this);
        originalSetRequestHeader.apply(this, arguments);

        var _arguments = Array.prototype.slice.call(arguments),
            header = _arguments[0],
            value = _arguments[1]; // Create a list for the header that if it does not exist


        if (!this._headers[header]) {
          this._headers[header] = [];
        } // Add the value to the header


        this._headers[header].push(value);
      };
    }
  }, {
    key: "sendProxyRequestFetch",
    value: function () {
      var _sendProxyRequestFetch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(proxySettings, originalFetch, resource, config) {
        var url, method, headers, body, proxyUrl, proxyMethod, analyticsName, proxyBody, proxyRequest, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = resource.url, method = resource.method, headers = resource.headers, body = resource.body;
                proxyUrl = proxySettings.url;
                proxyMethod = proxySettings.method || "POST";
                analyticsName = proxySettings.analyticsName;
                proxyBody = {
                  url: url,
                  method: method,
                  headers: headers,
                  body: body
                };
                proxyRequest = {
                  url: proxyUrl,
                  method: proxyMethod,
                  analyticsName: analyticsName,
                  body: proxyBody
                };
                proxyRequest = btoa(JSON.stringify(proxyRequest));
                _context2.next = 9;
                return originalFetch(proxyUrl, proxyRequest);

              case 9:
                response = _context2.sent;
                return _context2.abrupt("return", response);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function sendProxyRequestFetch(_x, _x2, _x3, _x4) {
        return _sendProxyRequestFetch.apply(this, arguments);
      }

      return sendProxyRequestFetch;
    }()
  }, {
    key: "sendProxyRequestAjax",
    value: function sendProxyRequestAjax(proxySettings, originalXHR, data) {
      var url = originalXHR._url,
          method = originalXHR._method,
          headers = originalXHR._headers;
      var body = method === "POST" ? data : null;
      var params = method === "GET" ? data : null;
      var proxyUrl = proxySettings.url;
      var proxyMethod = proxySettings.method || "POST";
      var analyticsName = proxySettings.analyticsName;
      var proxyBody = {
        url: url,
        method: method,
        headers: headers,
        body: body,
        params: params
      };
      var proxyRequest = {
        url: proxyUrl,
        analyticsName: analyticsName,
        method: proxyMethod,
        body: proxyBody
      };
      proxyRequest = btoa(JSON.stringify(proxyRequest));
      var newXHR = new XMLHttpRequest();
      newXHR.open(proxyMethod, proxyUrl, true);

      newXHR.onreadystatechange = function () {
        originalXHR.readyState = newXHR.readyState;
        originalXHR.response = newXHR.response;
        originalXHR.responseText = newXHR.responseText;
        originalXHR.responseType = newXHR.responseType;
        originalXHR.status = newXHR.status;
        originalXHR.statusText = newXHR.statusText;
        originalXHR.dispatchEvent(new Event('readystatechange'));
      }; // Handle the response from the new origin


      newXHR.addEventListener('load', function () {
        console.log('Response from new origin:', newXHR.responseText);
        originalXHR.dispatchEvent(new Event('load'));
      });
      newXHR.send(proxyRequest);
    }
  }]);
  return ProxyManager;
}();

exports["default"] = ProxyManager;